module.exports = __webpack_public_path__ + "static/media/main_teacher@2x.9414620c.png";